import { startseite } from "../../constants/const";

export default function KeinZugriff() {
    return(
        <div>
            <h3>Keine Rechte!</h3>
            
            <a href={startseite} >zur Startseite</a>
        </div>
    )
}